var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('section',{staticClass:"explain",attrs:{"id":"explain"}},[_c('b-container',[_c('div',{staticClass:"intro"},[_c('h2',[_vm._v(_vm._s(_vm.$t('pages.faq.title')))])])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('pages.faq.text'))}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12490fda","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Default/Faq.vue
// module id = 986
// module chunks = 1